<template>
  <div class="avue-top">
    <div class="top-bar__left" @click="toHomePage()">
      <img class="logo" :src="headLogoImg" @error="handleHeadLogoImgLoadingError()">
      <span class="avue-logo_title"
            >{{website.indexTitle}} </span>
    </div>
    <div class="top-bar__right">
      <img class="admin-image" src="../../../static/images/header/admin-logo.png">
      <el-dropdown>
        <span class="el-dropdown-link">
          {{userInfo.username}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <router-link to="/info/index">重置密码</router-link>
          </el-dropdown-item>
          <el-dropdown-item @click.native="logout">退出系统
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
  import {mapGetters, mapState} from "vuex";
  import topMenu from "./top-menu";
  import {remote} from '@/api/admin/dict';

  const defaultHeadLogoImg = require('../../../static/images/header/logo.jpg');

  export default {
    components: {
      topMenu
    },
    name: "top",
    data() {
      return {
        headLogoImg: '',
        defaultHeadLogoImg
      };
    },
    filters: {},
    created() {
    },
    mounted() {
      this.getHeadLogoImg();
    },
    computed: {
      ...mapState({
        showMenu: state => state.common.showMenu,
      }),
      ...mapGetters([
        "userInfo",
        "tagWel",
        "tagList",
        "tag",
        "logsLen",
        "logsFlag",
        "website"
      ])
    },
    methods: {
      logout() {
        this.$confirm("是否退出系统, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$store.dispatch("LogOut").then(() => {
            this.$router.push({path: "/login"});
          });
        });
      },
      toHomePage() {
        this.$router.push({
          path: `/wel/index`
        })
      },
      getHeadLogoImg() {
        remote("head_logo_img").then(response => {
          this.headLogoImg = response.data.data[0].value;
        })
      },
      handleHeadLogoImgLoadingError() {
        this.headLogoImg = this.defaultHeadLogoImg;
      }
    }
  };
</script>

<style lang="scss" scoped>
.el-icon-arrow-down {
        color: blue;
      }
.logo {
  height: 58%;
  width: 58%;
}
</style>
